import { ErrorHandler, ENVIRONMENT_INITIALIZER, APP_INITIALIZER, Provider } from '@angular/core';
import { Router } from '@angular/router';
import * as Sentry from '@sentry/angular';

import { environment } from '../../../../environments/environment';
import { appVersion } from '../../../../environments/version';
import { SentryErrorHandler } from '../kiwixi/error.exception';


export const sentryProviders: Provider[] = [
    {
        provide: ENVIRONMENT_INITIALIZER,
        useValue: () => {
            if (environment.production || environment.envName === 'staging') {
                Sentry.init({
                    dsn: environment.urls.sentryDsn,
                    release: appVersion,
                    environment: environment.envName,
                    integrations: [
                        Sentry.browserTracingIntegration(),
                        Sentry.replayIntegration({
                            maskAllText: false,
                            blockAllMedia: true,
                        }),
                    ],
                    tracesSampleRate: 0.05,
                    tracePropagationTargets: [
                        'localhost',
                        new RegExp(environment.server),
                        new RegExp(environment.urls.source),
                        new RegExp(environment.urls.url),
                    ],
                    replaysSessionSampleRate: 0.00,
                    replaysOnErrorSampleRate: 0.05,
                });
            }
        },
        multi: true,
    },
    {
        provide: ErrorHandler,
        useClass: SentryErrorHandler,
    },
    {
        provide: Sentry.TraceService,
        deps: [Router],
    },
    {
        provide: APP_INITIALIZER,
        useFactory: () => () => {},
        deps: [Sentry.TraceService],
        multi: true,
    },
];
